import { render } from "./resourcesclassifyedit.vue?vue&type=template&id=53b32564"
import script from "./resourcesclassifyedit.vue?vue&type=script&lang=js"
export * from "./resourcesclassifyedit.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__